import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { verticalEmbedModals } from './constants.js';
import { InsertModal } from './modals/InsertModal.js';
import 'ricos-schema';
import 'react';
import 'ricos-context';
import './toolbar/VerticalEmbedInsertModal.js';
import '@wix/design-system';
import 'lodash';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './dataHooks.js';
import './types.js';
import './toolbar/ItemsList.js';
import 'wix-rich-content-common/libs/imageUtils';
import './convertDuration.js';

const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(InsertModal, {
          modalId: verticalEmbedModals.replace
        }),
        id: verticalEmbedModals.replace,
        noPadding: true
      },
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        if (modals == null ? void 0 : modals.isModalOpen(verticalEmbedModals.replace)) {
          modals.closeModal(verticalEmbedModals.replace);
        } else {
          modals == null ? void 0 : modals.openModal(verticalEmbedModals.replace, {
            componentProps: {
              verticalsApi: config == null ? void 0 : config.verticalsApi,
              componentData: { type: selectedNode.attrs.type },
              nodeId: selectedNode.attrs.id
            },
            positioning: { placement: "bottom", referenceElement },
            layout: isMobile ? "fullscreen" : "popover"
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
